<template>
  <div id="atmMntcSchdMain" class="container">
    <main class="main-content">
      <article class="main">
        <QuickLink />
      </article>
      <article class="sub" style="padding-top: 0px; padding-right: 0.5rem; padding-left: 0.5rem;">
        <div class="search_area">
          <div class="grid-container">
            <div style="line-height: 35px;">
              배송처코드:
            </div>
            <div style="grid-column: 2 / -2;">
              <DxTextBox
                fontSize="20px"
                height="35px"
                v-model="searchData.dlvdId"
                :onEnterKey="handleAtmSearchModal"
              />
          </div>
          <button
            class="btn btn_type_01 font13"
            @click="handleAtmSearchModal"
          >
            ATM 추가
          </button>
          </div>
          <div style="margin-bottom: 10px;">
            <div style="display: flex; justify-content: space-between;">
              <button
                class="btn btn_type_01 font13"
                @click="showRegModal"
              >
                수행 결과
              </button>
              <button
                class="btn btn_type_01 summary"
              >
                총 {{ listTotalCnt }}건 / 완 {{ doneCnt }}건
              </button>
              <button
                class="btn btn_type_01 font13"
                @click="handleAtmDelete"
              >
                ATM 제거
              </button>
            </div>
          </div>
        </div>

        <div class="tbl font20" style="height: calc(100vh - (150px + 66px + 120px)); overflow: auto;">
          <div
            v-for="(schdInfo, atmIdx) in dataList"
            :key="`schdInfo-${atmIdx}`"
            class="border-top"
            @click.prevent="e => handleItemCheckClick(e, atmIdx)"
          >
            <div class="grid-list-container">
              <div class="grid-item disp-flex checkbox-div-align">
                <input
                  type="checkBox"
                  :id="`check_${atmIdx}`"
                  :checked="checkValList[atmIdx]"
                />
                <label :for="`check_${atmIdx}`"></label>
              </div>
              <div class="grid-atm-name">
                {{ schdInfo.atmNm }}
              </div>
              <div class="disp-flex checkbox-div-align stateName" name="stateName">
                <div class="grid-list-btn stateName" name="stateName">
                  {{ schdInfo.workDt ? '' : '미' }}완료
                </div>
              </div>
              <div class="disp-flex checkbox-div-align imgViewBtn" name="imgViewBtn">
                <div class="grid-list-btn imgViewBtn" name="imgViewBtn"
                  :style="{ backgroundColor: schdInfo.workDt ? '#2bd3c6' : '#fff' }"
                >
                  {{ schdInfo.workDt ? '사진' : ''}}
                </div>
              </div>
            </div>
          </div>
          <div v-if="isImageVisible" class="image-viewer" style="padding-top: 50px;">
            <span class="close" style="top: 0; right: 10px;" @click="closeImgViewer">&times;</span>
            <div style="overflow: scroll; height: 100%;">
              <div
                v-for="(imgUrl, imgIdx) in trgtImageUrls"
                :key="`img-${imgIdx}`"
                class="img_view_cover"
                :style="{marginRight: (imgIdx + 1) === trgtImageUrls.length ? '0px' : ''}"
              >
                <div class="img_view_header" style="position: inherit; top: 30px;">
                  <span style="background-color: black; padding: 5px;">
                    {{ `${imgIdx + 1} / ${trgtImageUrls.length}` }}
                  </span>
                </div>
                <img class="modal-content" id="full-image" :src="imgUrl" />
              </div>
            </div>
          </div>
        </div>
      </article>
    </main>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import AppConfig from '@/config'
import { EventBus } from '@/modules/event-bus'
import DxTextBox from 'devextreme-vue/text-box'
import { IMG_SERVER_URL } from '../customerCare'
import AtmMntcHstr from './AtmMntcHstr.vue'
import AtmSearchModal from './AtmSearchModal.vue'

import QuickLink from '@/components/QuickLink.vue'
import AtmMntcHstrUpdate from './AtmMntcHstrUpdate.vue'

export default {
  name: 'AtmMntcSchd',
  components: {
    DxTextBox,
    QuickLink
  },
  data () {
    const dataByYear = [
      {'code': moment().add(5, 'years').format('YYYY'), 'name': moment().add(5, 'years').format('YYYY')},
      {'code': moment().add(4, 'years').format('YYYY'), 'name': moment().add(4, 'years').format('YYYY')},
      {'code': moment().add(3, 'years').format('YYYY'), 'name': moment().add(3, 'years').format('YYYY')},
      {'code': moment().add(2, 'years').format('YYYY'), 'name': moment().add(2, 'years').format('YYYY')},
      {'code': moment().add(1, 'years').format('YYYY'), 'name': moment().add(1, 'years').format('YYYY')},
      {'code': moment().add(0, 'years').format('YYYY'), 'name': moment().add(0, 'years').format('YYYY')},
      {'code': moment().add(-1, 'years').format('YYYY'), 'name': moment().add(-1, 'years').format('YYYY')},
      {'code': moment().add(-2, 'years').format('YYYY'), 'name': moment().add(-2, 'years').format('YYYY')},
      {'code': moment().add(-3, 'years').format('YYYY'), 'name': moment().add(-3, 'years').format('YYYY')},
      {'code': moment().add(-4, 'years').format('YYYY'), 'name': moment().add(-4, 'years').format('YYYY')},
      {'code': moment().add(-5, 'years').format('YYYY'), 'name': moment().add(-5, 'years').format('YYYY')}
    ]
    const dataByMonth = [
      {'code': '01', 'name': '1월'},
      {'code': '02', 'name': '2월'},
      {'code': '03', 'name': '3월'},
      {'code': '04', 'name': '4월'},
      {'code': '05', 'name': '5월'},
      {'code': '06', 'name': '6월'},
      {'code': '07', 'name': '7월'},
      {'code': '08', 'name': '8월'},
      {'code': '09', 'name': '9월'},
      {'code': '10', 'name': '10월'},
      {'code': '11', 'name': '11월'},
      {'code': '12', 'name': '12월'}
    ]
    return {
      dataByYear,
      dataByMonth,
      databyAtmMntcChcekCd: [],
      api_prefixUrl: '/api/purchase/customerCare',
      api_schdListUrl: 'atmMntcSchdList',
      api_atmMntcInfoUrl: 'getAtmMntcInfoBySchd',
      api_takeMntcShcdItemUrl: 'takeMntcShcdItem',
      api_removeMntcShcdItemUrl: 'removeMntcShcdItem',
      pagingData: {
        skip: 0,
        rowCount: 20
      },
      searchData: {
        year: moment().format('YYYY'),
        month: moment().format('MM'),
        term: '',
        dlvdId: '',
        condition: '',
        conditionText: '',
        atmNm: ''
      },
      dataList: [],
      listTotalCnt: 0,
      doneCnt: 0,
      checkValList: [],
      cacheSearchData: null,
      cachePagingData: null,
      isImageVisible: false
    }
  },
  computed: {
    userId () {
      return window.$store.getters['Login/getUserId']
    },
    getRoutePath () {
      return this.$route.path
    },
    checkedItemList () {
      if (this.allCheck) {
        return this.dataList.map(obj => {
          const { sersNum } = obj
          return { sersNum }
        })
      }
      const resList = []
      this.checkValList.forEach((val, idx) => {
        if (val) {
          const { sersNum } = this.dataList[idx]
          resList.push({ sersNum })
        }
      })
      return resList
    },
    getStoreCompObjs () {
      return window.$store.getters['ModalStore/getModalObjs']
    }
  },
  watch: {
    getRoutePath (newVal) {
      if (newVal === '/customerCare/atmMntcSchd') {
        this.handleSearch(true)
        const { doShowModal } = this.$route.params
        if (doShowModal) {
          setTimeout(() => {
            this.showRegModal()
          }, 100)
        }
      }
    },
    getStoreCompObjs (newVal, oldVal) {
      if (newVal.length === 0 && oldVal.length > 0 && oldVal[0].comp.name === 'AtmMntcHstr') {
        this.handleSearch(true)
      }
    }
  },
  created () {
    this.regEventBus()
  },
  mounted () {
    this.getComnCodeList('ATM_MNTC_CHCK_CD')
    this.handleSearch()
    const { doShowModal } = this.$route.params
    if (doShowModal) {
      setTimeout(() => {
        this.showRegModal()
      }, 100)
    }
  },
  methods: {
    regEventBus () {
      EventBus.$on('atmMntcSchd-atm-add', (paramList) => {
        const apiParamList = paramList.map(obj => {
          return {
            atmNum: obj.atm_num,
            prchChnlAfliNum: obj.com_num,
            dlvrCd: obj.dlvd_id
          }
        })
        this.takeMntcShcdItem(apiParamList)
      })
    },
    async takeMntcShcdItem (apiParamList) {
      const apiRes = await this.$http.post(
        `${this.api_prefixUrl}/${this.api_takeMntcShcdItemUrl}`,
        apiParamList
      )

      if (apiRes) {
        const { data: { result, status } } = apiRes
        if (status === '200') {
          if (result.errMsg) {
            this.$Alert.alert(result.errMsg)
            return
          }
          this.$Alert.alert(result.resMsg).then(() => {
            window.$store.commit('ModalStore/hideModal', this.getStoreCompObjs.length - 1)
            this.handleSearch(true)
          })
        }
      }
    },
    handleAtmDelete () {
      this.$Alert.confirm(`선택하신 ${this.checkedItemList.length}건이 스케줄에서 제외됩니다.`)
        .then(res => {
          if (res) {
            this.removeSchd()
            return
          }
        })
    },
    async removeSchd () {
      const apiRes = await this.$http.post(
        `${this.api_prefixUrl}/${this.api_removeMntcShcdItemUrl}`,
        this.checkedItemList
      )

      if (apiRes) {
        const { data: { result, status } } = apiRes
        if (status === '200') {
          if (result.errMsg) {
            this.$Alert.alert(result.errMsg)
            return
          }
          this.$Alert.alert(result.resMsg).then(() => {
            this.handleSearch(true)
          })
        }
      }
    },
    async handleSearch (buttonClick) {
      if (buttonClick) {
        this.dataList = []
        this.pagingData.skip = 0
      }

      const year = `${moment().format('YYYY')}`
      const month = `${moment().subtract(1, 'month').format('MM')}`
      const lastDay = `${moment().subtract(1, 'month').endOf('month').format('DD')}`
      const startDate = `${year}-${month}-01`
      const endDate = `${year}-${month}-${lastDay}`

      const params = {
        ...this.searchData,
        skip: this.pagingData.skip,
        take: this.pagingData.rowCount,
        condition: '3',
        conditionText: this.userId,
        mobile: 'mobile',
        startDate,
        endDate
      }

      const res = await Vue.httpClient.get(
        `${this.api_prefixUrl}/${this.api_schdListUrl}`,
        { params }
      )

      if (res) {
        const { data: { result: { list }, status } } = res
        if (status === '200') {
          this.dataList = list
          this.checkValList = list.map(_obj => false)

          this.listTotalCnt = list.length
          this.doneCnt = list.filter(obj => obj.workDt).length
        }
      }
    },
    async getComnCodeList (cmnsCdGrpId) {
      const { data } = await this.$http.get(`/api/appmgmt/common/code/list?cmnsCdGrpId=${cmnsCdGrpId}`)
      if (data.status === AppConfig.HTTP_RESPONSE_SUCCESS && data.result) {
        data.result.forEach(item => {
          this.databyAtmMntcChcekCd.push({
            code: item.cmnsCd,
            value: item.cmnsCdNm
          })
        })
      }
    },
    handleUpdate (data) {
      this.$router.push({name: 'AtmMntcSchdUpdate', params: { data }})
    },
    handleAtmSearchModal () {
      window.$store.commit('ModalStore/addModal', {
        comp: AtmSearchModal,
        title: 'ATM 목록',
        propData: {
          propDlvdId: this.searchData.dlvdId
        }
      })
    },
    showRegModal () {
      window.$store.commit('ModalStore/addModal', {
        comp: AtmMntcHstr,
        title: '내가 등록한 유지보수 목록',
        propData: {
          isModal: true
        }
      })
    },
    formatDate (value) {
      if (value) {
        return moment(value).format('yyyy-MM-DD')
      } else {
        return ''
      }
    },
    handleItemCheckClick (e, trgtIdx) {
      const { target: { classList } } = e
      if (!classList.contains('grid-list-btn')) {
        this.checkValList = this.checkValList.map((val, idx) => {
          if (idx !== trgtIdx) {
            return val
          }
          return !val
        })
        return
      }

      if (classList.contains('imgViewBtn') || classList.contains('stateName')) {
        const { workDt } = this.dataList[trgtIdx]
        if (workDt) { // atmMntcHstrNum !== 0
          this.getMntcHstrInfo(this.dataList[trgtIdx], classList)
        } else if (classList.contains('stateName')) {
          const lng = this.dataList[trgtIdx].atmLngtVal
          const lat = this.dataList[trgtIdx].atmLtdVal
          if (lng && lat) {
            const latLngToEPSG3857 = (latitude, longitude) => {
              const x = longitude * 20037508.34 / 180
              let y = Math.log(Math.tan((90 + latitude) * Math.PI / 360)) / (Math.PI / 180)
              y = y * 20037508.34 / 180
              return { x, y }
            }

            const { x, y } = latLngToEPSG3857(lat * 1, lng * 1)
            window.open(`http://map.naver.com/v5/search?c=${x},${y},16,0,0,0,dh`, '_blank')
          }
        }
      }
    },
    async getMntcHstrInfo (trgtObj, classList) {
      const apiRes = await this.$http.post(
        `${this.api_prefixUrl}/${this.api_atmMntcInfoUrl}`,
        {
          ...trgtObj,
          workDate: trgtObj.workDt
        }
      )

      if (apiRes) {
        const { data: { result, status } } = apiRes
        if (status === '200' && result) {
          const { atmMntcHstrNum, apndFlInfo, extlChckFlInfo } = result
          if (classList.contains('imgViewBtn')) {
            const splitStr = '/%/'
            let imgFlInfo = `${apndFlInfo}`
            if (extlChckFlInfo) {
              const extlFlInfo = extlChckFlInfo
                .split(',')
                .map(item => item.trim())
                .filter(Boolean)
                .join('/%/')

              imgFlInfo = `${apndFlInfo}${splitStr}${extlFlInfo}`
            }
            this.handleVisibleImage(imgFlInfo)
          } else if (classList.contains('stateName')) {
            window.$store.commit('ModalStore/addModal',
              {
                comp: AtmMntcHstrUpdate,
                title: '유지보수 결과 수정',
                propData: {
                  atmMntcHstrNum
                }
              })
          }
        }
      }
    },
    handleVisibleImage (imgFlInfo) {
      if (imgFlInfo) {
        this.trgtImageUrls = imgFlInfo.split('/%/').map(url => {
          return IMG_SERVER_URL + url
        })

        this.imageUrl = IMG_SERVER_URL + imgFlInfo
        this.isImageVisible = true
      }
    },
    closeImgViewer () {
      this.isImageVisible = false
      this.trgtImageUrls = []
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isImageVisible) {
      this.isImageVisible = false
      next(false)
    } else {
      next()
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/views/customerCare/AtmMntcSchd.vue